/* kn-sale-muur.js — hoort bij sections/kn-lx-sale-muur.liquid (sale-lander 7 JARIG BESTAAN, filmposter).
 *
 * Geen library, geen canvas. Alles wat beweegt is CSS (transform/opacity); dit script zet alleen
 * klassen, getallen en één transform (muisparallax) — in requestAnimationFrame, nooit in een
 * scroll-listener. De muur loopt vanaf de eerste paint (CSS-animatie); JS pauzeert hem alleen.
 *   0. aftelklok  — 1-op-1 overgenomen uit kn-sale3d.js (bootClock); alleen de naam van het tick-event
 *                   is anders. De korte flip bij een cijferwissel zit in een MutationObserver ernaast.
 *   1. entree     — "de lichten gaan uit": .is-in op de hero na max(450 ms, min(fonts.ready, 700 ms)).
 *                   De muur staat dus eerst even vol aan; dan valt de falloff in en komt de copy op.
 *   2. muur       — pauze (.is-paused) bij verborgen tab en buiten beeld; muisparallax ±10 px op desktop.
 *   3. formulier  — laadstand op de knop, bevestigingsregel na succes (kn-lx.js zet de statusregel;
 *                   wij lezen die mee), foutmelding blijft in de aria-live-regel; na succes krijgen ook de
 *                   andere formulieren de bevestiging, en de .ics-agendalink wordt client-side gevuld (bootIcs).
 *   4. onthullen  — feiten, grootboek en statement komen één keer in beeld (IntersectionObserver .15).
 *   5. sticky     — inschrijfbalk zodra het hero-formulier uit beeld is (patroon kn-lx-sale3d).
 *
 * Het formulier zelf wordt door assets/kn-lx.js afgehandeld ([data-lx-capture-form]).
 */
(function (w, d) {
  'use strict';

  var REDUCE = !!(w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var FINE = !!(w.matchMedia && w.matchMedia('(hover: hover) and (pointer: fine)').matches);

  /* ------------------------------------------------------------ 0. aftelklok
     Rekent elke seconde opnieuw vanaf Date.now() tegen het vaste UTC-moment uit
     data-starts (ISO 8601, 'Z'). Nooit optellen, dus nooit achterlopen. Het
     interval stopt bij document.hidden en herberekent meteen bij terugkomen.
     Onder nul: klok weg, "open"-tekst en -knop erin, formulier weg. */

  function bootClock(root) {
    var el = root.querySelector('[data-kn-clock]');
    if (!el) return;
    var starts = Date.parse(el.getAttribute('data-starts') || '');
    if (isNaN(starts)) return;

    var q = function (sel) { return root.querySelector(sel); };
    var num = { d: q('[data-kn-clock-d]'), h: q('[data-kn-clock-h]'),
                m: q('[data-kn-clock-m]'), s: q('[data-kn-clock-s]') };
    var row = q('[data-kn-clock-row]'), label = q('[data-kn-clock-label]');
    var open = q('[data-kn-clock-open]'), openCta = q('[data-kn-open-cta]');
    var lead = q('[data-kn-lead]'), form = q('form[data-lx-capture-form]');
    var bar = q('[data-kn-clock-bar]'), barFill = bar && bar.firstElementChild;
    var timer = 0, last = -1, lastF = 2;

    function pad(n) { return (n < 10 ? '0' : '') + n; }

    function openUp() {
      stop();
      if (row) row.hidden = true;
      if (label) label.hidden = true;
      if (bar) bar.hidden = true;
      if (open) open.hidden = false;
      if (form) form.hidden = true;
      if (openCta) openCta.hidden = false;
      var openLead = root.getAttribute('data-open-lead');
      if (lead && openLead) lead.textContent = openLead;
      root.classList.add('is-open');
      var sl = d.querySelector('.kn-mw__slot'); if (sl) sl.classList.add('is-open');
    }

    function tick() {
      var left = Math.max(0, Math.floor((starts - Date.now()) / 1000));
      if (left === last) return;                     // niets veranderd: niets schrijven
      last = left;
      if (left === 0) { openUp(); return; }
      if (num.d) num.d.textContent = pad(Math.floor(left / 86400));
      if (num.h) num.h.textContent = pad(Math.floor(left % 86400 / 3600));
      if (num.m) num.m.textContent = pad(Math.floor(left % 3600 / 60));
      if (num.s) num.s.textContent = pad(left % 60);
      /* De seconden als haarlijn: één transform per seconde, met een lineaire overgang van 1 s ertussen.
         Bij de sprong van 00 terug naar 59 even zonder overgang, anders veegt de lijn zichtbaar terug. */
      if (barFill) {
        var f = (left % 60) / 60;
        if (REDUCE || f > lastF) { barFill.style.transition = 'none'; barFill.style.transform = 'scaleX(' + f.toFixed(3) + ')'; void barFill.offsetWidth; if (!REDUCE) barFill.style.transition = ''; }
        else barFill.style.transform = 'scaleX(' + f.toFixed(3) + ')';
        lastF = f;
      }
      try { root.dispatchEvent(new CustomEvent('kn-sale-muur:tick')); } catch (e) {}
    }

    function start() { if (!timer) { tick(); timer = setInterval(tick, 1000); } }
    function stop() { if (timer) { clearInterval(timer); timer = 0; } }

    d.addEventListener('visibilitychange', function () { if (d.hidden) stop(); else start(); });
    w.addEventListener('pagehide', stop, { once: true });
    start();
  }

  /* Cijferwissel: korte flip (CSS .is-tick, transform/opacity). Los van bootClock,
     zodat die letterlijk hetzelfde blijft als in kn-sale3d.js. */
  function bootClockSlide(root) {
    if (REDUCE || !('MutationObserver' in w)) return;
    var nums = root.querySelectorAll('.kn-mw__clock-num:not([data-kn-clock-s])');   /* seconden wisselen zonder flip: geen knipperlicht boven het veld */
    for (var i = 0; i < nums.length; i++) {
      (function (el) {
        /* bootClock schrijft elke seconde alle vier de spans, ook als de waarde gelijk blijft; de mutation vuurt
           dan toch. Alleen flippen bij een echte waardewissel, anders knipperen dagen/uren/minuten elke seconde mee. */
        var last = el.textContent;
        new MutationObserver(function () {
          var now = el.textContent;
          if (now === last) return;
          last = now;
          el.classList.remove('is-tick'); void el.offsetWidth; el.classList.add('is-tick');
        }).observe(el, { childList: true, characterData: true, subtree: true });
      })(nums[i]);
    }
    /* datum rechtsboven na de start */
    var bar = root.querySelector('[data-kn-mw-bar]'), openBar = root.getAttribute('data-open-bar');
    if (bar && openBar) {
      var setBar = function () { if (root.classList.contains('is-open')) bar.firstElementChild.textContent = openBar; };
      setBar();   /* bootClock kan de klok al op open hebben gezet vóór deze observer bestond */
      new MutationObserver(setBar).observe(root, { attributes: true, attributeFilter: ['class'] });
    }
  }

  /* --------------------------------------------------------------- 1. entree
     De verlichte muur moet eerst registreren: nooit vóór 450 ms. Fonts klaar = go, met een plafond
     van 700 ms zodat een trage Typekit de opening niet ophoudt (de copy is opacity 0, dus een late
     swap schuift niets zichtbaars). */
  function bootEntrance(root) {
    var hero = root.querySelector('[data-kn-mw-hero]');
    if (!hero) return;
    /* De copy loopt op CSS-animaties met een vaste vertraging vanaf de eerste paint (de H1/LCP wacht op niets).
       De falloff wacht op de eager tegels (eerste kopie, rij 1-2) met een plafond van 1,5 s, zodat de muur
       eerst één keer vol aan staat; tegels faden in zodra ze geladen zijn. */
    var imgs = [].slice.call(root.querySelectorAll('.kn-mw__tile img'));
    imgs.forEach(function (i) { var on = function () { i.classList.add('is-loaded'); }; if (i.complete && i.naturalWidth) on(); else { i.addEventListener('load', on, { once: true }); i.addEventListener('error', on, { once: true }); } });
    if (REDUCE) { hero.classList.add('is-in'); return; }
    var eager = imgs.filter(function (i) { return i.getAttribute('loading') === 'eager'; });
    /* De cookiebalk dekt op de eerste visite de hele muur af: dan wacht de entree tot hij weg is (max 6 s), zodat
       niemand de duurste animatie achter een wit paneel mist. Zonder balk of bij herhaalbezoek speelt hij meteen. */
    var cc = d.querySelector('.kn-cc'), waitCc = !!(cc && !cc.hasAttribute('hidden'));
    var fired = false, fire = function () { if (fired) return; fired = true; w.requestAnimationFrame(function () { hero.classList.add('is-in'); }); };
    if (waitCc) {
      var ccGone = function () { if (cc.hasAttribute('hidden') || !cc.classList.contains('is-in')) { fire(); } };
      new MutationObserver(ccGone).observe(cc, { attributes: true, attributeFilter: ['class', 'hidden'] });
      setTimeout(fire, 6000);
      return;
    }
    Promise.all(eager.map(function (i) { return (i.decode ? i.decode() : Promise.resolve()).catch(function () {}); })).then(fire, fire);
    setTimeout(fire, 1500);
  }

  /* ----------------------------------------------------------------- 2. muur
     De banden lopen op CSS vanaf de eerste paint. Hier alleen: pauze bij verborgen tab / buiten beeld,
     en de muisparallax (±10 px, lerp .08 per frame) voor een fijne pointer op desktop. */
  function bootWall(root) {
    var wall = root.querySelector('[data-kn-mw-wall]'), par = root.querySelector('[data-kn-mw-par]'), hero = root.querySelector('[data-kn-mw-hero]');
    if (!wall || !hero) return;
    var seen = true;
    function sync() { wall.classList.toggle('is-paused', d.hidden || !seen); }
    d.addEventListener('visibilitychange', sync);
    if ('IntersectionObserver' in w) new IntersectionObserver(function (en) { seen = en[0].isIntersecting; sync(); }, { threshold: 0 }).observe(hero);
    sync();
    if (REDUCE || !par || !FINE || !w.matchMedia('(min-width: 900px)').matches) return;

    var tx = 0, ty = 0, cx = 0, cy = 0, raf = 0;
    function frame() {
      raf = 0;
      cx += (tx - cx) * 0.08; cy += (ty - cy) * 0.08;
      par.style.transform = 'translate3d(' + cx.toFixed(2) + 'px,' + cy.toFixed(2) + 'px,0)';
      if (Math.abs(tx - cx) > 0.05 || Math.abs(ty - cy) > 0.05) raf = w.requestAnimationFrame(frame);
    }
    function want() { if (!raf && seen) raf = w.requestAnimationFrame(frame); }
    hero.addEventListener('mousemove', function (e) {
      var r = hero.getBoundingClientRect();
      tx = ((e.clientX - r.left) / r.width - 0.5) * 20;   /* ±10 px */
      ty = ((e.clientY - r.top) / r.height - 0.5) * 20;
      want();
    }, { passive: true });
    hero.addEventListener('mouseleave', function () { tx = 0; ty = 0; want(); });
  }

  /* ------------------------------------------------------- 2b. muur en scroll
     Twee dingen, allebei in één rAF-lus die alleen loopt zolang de hero in beeld is en er beweging is:
       diepte   elke band krijgt een eigen vertraging op de scrollpositie (translate3d op .kn-mw__row —
                de band zelf houdt zijn eigen translateX-animatie, dus ze bijten elkaar niet);
       vaart    de lopende banden versnellen mee met de scrollsnelheid (playbackRate van de CSS-animatie)
                en zakken daarna terug naar 1. Geen layout, geen repaint: alles op de compositor. */
  function bootScroll(root) {
    if (REDUCE) return;
    var hero = root.querySelector('[data-kn-mw-hero]');
    var rows = [].slice.call(root.querySelectorAll('.kn-mw__row'));
    if (!hero || !rows.length) return;
    var DEPTH = [0.05, 0.11, 0.17, 0.08];
    var anims = [];
    if (rows[0].getAnimations) {
      for (var a = 0; a < rows.length; a++) {
        var tr = rows[a].querySelector('.kn-mw__track');
        if (tr) { try { anims = anims.concat(tr.getAnimations()); } catch (e) {} }
      }
    }
    var seen = true, raf = 0, prevY = w.scrollY || 0, prevT = 0, rate = 1, target = 1, applied = [];
    function frame(t) {
      raf = 0;
      var y = w.scrollY || 0;
      var dt = prevT ? Math.max(8, t - prevT) : 16;
      var v = Math.abs(y - prevY) / dt * 16;                       /* px per frame van 60 fps */
      prevY = y; prevT = t;
      target = 1 + Math.min(1.3, v / 26);          /* hooguit 2,3× : een zwiep, geen sprint */
      rate += (target - rate) * 0.14;
      if (anims.length) for (var k = 0; k < anims.length; k++) { try { anims[k].playbackRate = rate; } catch (e) {} }
      var h = hero.offsetHeight || 1, off = Math.min(y, h);
      for (var i = 0; i < rows.length; i++) {
        var px = Math.round(off * (DEPTH[i] || 0.1) * 10) / 10;
        if (applied[i] !== px) { rows[i].style.transform = 'translate3d(0,' + px + 'px,0)'; applied[i] = px; }
      }
      if (seen && (Math.abs(rate - 1) > 0.01 || v > 0.2)) want();
    }
    function want() { if (!raf && seen) raf = w.requestAnimationFrame(frame); }
    w.addEventListener('scroll', want, { passive: true });
    w.addEventListener('resize', want, { passive: true });
    if ('IntersectionObserver' in w) new IntersectionObserver(function (en) { seen = en[0].isIntersecting; if (seen) { prevT = 0; want(); } }, { threshold: 0 }).observe(hero);
    want();
  }

  /* Eén keer op de lijst = de pagina vraagt niet nog een keer: de andere formulieren tonen dezelfde bevestiging (zonder focus). */
  function settleOthers(f) {
    var all = d.querySelectorAll('[data-kn-mw-form]');
    for (var i = 0; i < all.length; i++) {
      var o = all[i]; if (o === f || o.classList.contains('is-done')) continue;
      var oi = o.querySelector('[data-lx-capture-email]'), ob = o.querySelector('button[type=submit]'), od = o.querySelector('[data-kn-mw-done]');
      if (oi) oi.disabled = true; if (ob) ob.disabled = true;
      if (od) { o.classList.add('is-done'); od.hidden = false; od.classList.add('is-in'); }
    }
  }

  /* Agenda-link (.ics) in de bevestiging: client-side gemaakt uit data-starts (UTC) van de klok; één uur, herinnering 15 min vooraf.
     Blob-URL (iOS opent die als agenda-item), data-URL als terugval. Geen request, geen nieuwe feiten: alleen datum/tijd + de paginalink. */
  function bootIcs(root) {
    var links = d.querySelectorAll('[data-kn-mw-ics]'); if (!links.length) return;   /* ook de link in het (verplaatste) slot */
    var clock = root.querySelector('[data-kn-clock]'), starts = Date.parse((clock && clock.getAttribute('data-starts')) || '');
    if (isNaN(starts)) return;
    function ts(t) { return new Date(t).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, ''); }
    function esc(x) { return String(x).replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,').replace(/\r?\n/g, '\\n'); }
    for (var i = 0; i < links.length; i++) {
      var a = links[i], title = a.getAttribute('data-ics-title') || d.title, url = a.getAttribute('data-ics-url') || location.href.split('#')[0];
      var ics = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Kosso Nutrition//sale-7jaar//NL', 'CALSCALE:GREGORIAN', 'METHOD:PUBLISH',
        'BEGIN:VEVENT', 'UID:sale-7jaar-' + ts(starts) + '@kossonutrition.nl', 'DTSTAMP:' + ts(Date.now()), 'DTSTART:' + ts(starts), 'DTEND:' + ts(starts + 3600000),
        'SUMMARY:' + esc(title), 'DESCRIPTION:' + esc(url), 'URL:' + url,
        'BEGIN:VALARM', 'TRIGGER:-PT15M', 'ACTION:DISPLAY', 'DESCRIPTION:' + esc(title), 'END:VALARM', 'END:VEVENT', 'END:VCALENDAR'].join('\r\n');
      var href = 'data:text/calendar;charset=utf-8,' + encodeURIComponent(ics);
      try { if (w.Blob && w.URL && w.URL.createObjectURL) href = w.URL.createObjectURL(new Blob([ics], { type: 'text/calendar;charset=utf-8' })); } catch (e) {}
      a.setAttribute('href', href);
    }
  }

  /* ------------------------------------------------------------ 3. formulier
     kn-lx.js zet bij submit synchroon de statusregel (lx-capture__msg is-ok|is-err). We tonen de
     laadstand minstens 600 ms, dan de bevestigingsregel; bij een fout meteen terug naar de knop. */
  function bootForms(root) {
    /* Op document, niet op root: boot() verplaatst het slot (tweede formulier) vóór dit draait tot achter de FAQ, dus buiten de sectie. */
    var forms = d.querySelectorAll('[data-kn-mw-form]');
    for (var i = 0; i < forms.length; i++) {
      (function (f) {
        var msg = f.querySelector('[data-lx-capture-msg]'), done = f.querySelector('[data-kn-mw-done]'), t0 = 0;
        var inp = f.querySelector('[data-lx-capture-email]'), btn = f.querySelector('button[type=submit]'), fld = f.querySelector('.kn-mw__field');
        if (!msg) return;
        /* Capture-fase op document: kn-lx.js heeft zijn submit-listener eerder op het formulier gezet en zet de statusregel synchroon;
           bij een echte (native) submit draait de MutationObserver-microtask al tússen die listener en de onze, dus zonder
           capture zou settle() vóór t0 lopen en de laadstand overslaan (gemeten: is-done na 17 ms in plaats van 600 ms). */
        d.addEventListener('submit', function (e) { if (e.target !== f) return; t0 = Date.now(); f.classList.add('is-busy'); if (btn) btn.setAttribute('aria-busy', 'true'); }, true);
        f.addEventListener('input', function () { f.classList.remove('is-err'); if (inp) inp.removeAttribute('aria-invalid'); });
        function settle() {
          var ok = msg.classList.contains('is-ok'), err = msg.classList.contains('is-err');
          if (!ok && !err) return;
          if (!t0) { t0 = Date.now(); f.classList.add('is-busy'); if (btn) btn.setAttribute('aria-busy', 'true'); }   /* terugval: laadstand nooit overslaan */
          var wait = ok ? Math.max(0, 600 - (Date.now() - t0)) : 0;
          f.classList.toggle('is-err', err);
          if (inp) { if (err) inp.setAttribute('aria-invalid', 'true'); else inp.removeAttribute('aria-invalid'); }
          if (err && !REDUCE && fld) { fld.classList.remove('is-nudge'); void fld.offsetWidth; fld.classList.add('is-nudge'); }
          setTimeout(function () {
            f.classList.remove('is-busy'); if (btn) btn.removeAttribute('aria-busy');
            /* wachtlijst (plafond vol): geen "je staat op de lijst"-bevestiging, de statusregel zegt het; de teller gaat naar vol */
            if (ok && f.getAttribute('data-list') === 'waitlist') { try { d.dispatchEvent(new CustomEvent('kn:cap-full')); } catch (e) {} return; }
            if (ok && done) { f.classList.add('is-done'); done.hidden = false; done.setAttribute('tabindex', '-1'); w.requestAnimationFrame(function () { done.classList.add('is-in'); try { done.focus({ preventScroll: true }); } catch (e) {} }); }
            if (ok) settleOthers(f);
          }, wait);
        }
        if ('MutationObserver' in w) new MutationObserver(settle).observe(msg, { attributes: true, attributeFilter: ['class'] });
        else f.addEventListener('submit', function () { setTimeout(settle, 60); });
      })(forms[i]);
    }
  }

  /* ------------------------------------------------------------- 4. onthullen
     Vast onthuld (eigen CSS): de feiten, het grootboek, het statement, de cadeau-rij, de footer.
     Daarnaast krijgt alles uit EXTRA de generieke klasse .kn-mw__reveal — maar alléén als het bij het laden nog
     onder de vouw staat. Wat al in beeld is blijft gewoon staan: geen flits, en geen opacity op de eerste paint. */
  var EXTRA = '.kn-mw__urg-head, .kn-mw__cards-more, .kn-mw__gift-sub, .kn-mw__slot-text, .kn-mw__slot .kn-mw__form, .lx-faq details, .lx-reviews__head, .lx-review';

  function bootReveal(root) {
    var els = [].slice.call(root.querySelectorAll('.kn-mw__facts li, .kn-mw__card, .kn-mw__statement, .kn-mw__gift-tile'));
    var foot = d.querySelector('.lx-footer'); if (foot) els.push(foot);   /* footer: één keer in beeld (400 ms) */
    var i;
    if (REDUCE || !('IntersectionObserver' in w)) { for (i = 0; i < els.length; i++) els[i].classList.add('is-in'); return; }
    var extra = [].slice.call(d.querySelectorAll(EXTRA)), below = w.innerHeight * 0.92;
    for (i = 0; i < extra.length; i++) {
      if (extra[i].getBoundingClientRect().top > below) { extra[i].classList.add('kn-mw__reveal'); els.push(extra[i]); }
    }
    if (!els.length) return;
    var io = new IntersectionObserver(function (en) {
      var n = 0;
      for (var k = 0; k < en.length; k++) if (en[k].isIntersecting) { en[k].target.style.setProperty('--i', n++); en[k].target.classList.add('is-in'); io.unobserve(en[k].target); }
    }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
    for (i = 0; i < els.length; i++) io.observe(els[i]);
  }

  /* --------------------------------------------------------------- 5. sticky */
  function bootSticky(root) {
    var hero = root.querySelector('.kn-mw__form--hero'), bar = root.querySelector('[data-kn-mw-sticky]');
    if (!hero || !bar || !('IntersectionObserver' in w)) return;
    var done = false; try { done = localStorage.getItem('kn_lx_lead') === '1'; } catch (e) {}
    if (done) { bar.hidden = true; return; }
    var heroSeen = true, slotSeen = false, slot = d.querySelector('.kn-mw__form--slot');   /* het slot staat na boot() achter de FAQ, buiten root */
    function sync() {
      var on = !heroSeen && !slotSeen && !footerSeen && !done && !root.classList.contains('is-open') && hero.getBoundingClientRect().bottom < 0;
      bar.classList.toggle('is-on', on); d.body.classList.toggle('kn-mw-sticky-on', on);
    }
    new IntersectionObserver(function (en) { heroSeen = en[0].isIntersecting; sync(); }, { threshold: 0 }).observe(hero);
    if (slot) new IntersectionObserver(function (en) { slotSeen = en[0].isIntersecting; sync(); }, { threshold: 0 }).observe(slot);
    /* Ook uit zodra de footer in beeld is (op 320 px staat het slot al uit beeld terwijl de footer nog zichtbaar is). */
    var footer = d.querySelector('.lx-footer'), footerSeen = false;
    if (footer) new IntersectionObserver(function (en) { footerSeen = en[0].isIntersecting; sync(); }, { threshold: 0 }).observe(footer);
    w.addEventListener('scroll', sync, { passive: true });
    d.addEventListener('submit', function (e) {
      if (!e.target.hasAttribute('data-lx-capture-form')) return;
      setTimeout(function () {
        try { done = localStorage.getItem('kn_lx_lead') === '1'; } catch (x) {}
        if (done) setTimeout(function () { bar.classList.remove('is-on'); d.body.classList.remove('kn-mw-sticky-on'); }, 2500);
      }, 50);
    });
  }

  /* ------------------------------------------------------------ 6. op de hero
     Wie via een Instagram/Facebook-ad binnenkomt, belandt soms meteen bij het onderste formulier (video Tufan,
     03-10-2026; Clarity: IG-sessies van 1-3 s met 85-100 % scrolldiepte, al vóór de Klaviyo-wijziging). Niet ons
     script: de in-app browser van Meta biedt automatisch invullen van het e-mailveld aan en scrolt daarvoor naar
     het laatste e-mailveld op de pagina. Daarom: zolang de bezoeker zelf nog niets heeft gedaan (aanraken, klikken,
     wiel, toets) en hooguit 8 s na het laden, gaat elke scroll terug naar boven en verliest een veld onder de vouw
     zijn focus. Met een #anker in de URL blijft alles zoals het was. */
  function bootHold() {
    if (location.hash) return;
    var logged = false;
    try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch (e) {}
    var root = d.documentElement, done = false, t0 = Date.now();
    var gestures = ['touchstart', 'pointerdown', 'mousedown', 'wheel', 'keydown'];
    function release() { if (done) return; done = true; gestures.forEach(function (ev) { w.removeEventListener(ev, release, true); }); w.removeEventListener('scroll', hold, true); }
    function hold() {
      if (done) return;
      if (Date.now() - t0 > 8000) { release(); return; }
      if ((w.scrollY || w.pageYOffset || 0) < 2) return;
      var a = d.activeElement;
      if (a && a.tagName === 'INPUT' && a.getBoundingClientRect().top > w.innerHeight) { try { a.blur(); } catch (e) {} }
      /* html heeft scroll-behavior:smooth (kn-lx.css); 'instant' kent oudere Safari niet, dus even uitzetten */
      var sb = root.style.scrollBehavior; root.style.scrollBehavior = 'auto'; w.scrollTo(0, 0); root.style.scrollBehavior = sb;
      if (!logged) { logged = true; try { (w.dataLayer = w.dataLayer || []).push({ event: 'lp_autoscroll_blocked' }); } catch (e) {} }
    }
    gestures.forEach(function (ev) { w.addEventListener(ev, release, { capture: true, passive: true }); });
    w.addEventListener('scroll', hold, { capture: true, passive: true });
    hold();
  }

  function boot() {
    bootHold();
    /* De reviews-lijst is op deze pagina geen scrollgebied meer (CSS stapelt de quotes): tabindex weg, anders een lege tabstop. */
    /* Slot (tweede formulier) achter de FAQ: de laatste vraag beantwoord = de laatste vraag gesteld. Ver onder de vouw, dus geen zichtbare verschuiving. */
    var slotEl = d.querySelector('.kn-mw__slot'), faqEl = d.querySelector('.lx-faq');
    if (slotEl && faqEl) { var faqSec = faqEl.closest('.shopify-section') || faqEl; faqSec.parentNode.insertBefore(slotEl, faqSec.nextSibling); }
    var tr = d.querySelectorAll('.lx-reviews__track[tabindex]');
    for (var t = 0; t < tr.length; t++) tr[t].removeAttribute('tabindex');
    var by = d.querySelectorAll('.lx-review__by > span:not(.lx-sr):not(.lx-stars)');
    for (var y = 0; y < by.length; y++) by[y].textContent = by[y].textContent.replace(/^\s*·\s*/, '');
    /* Cookiebalk staat vast bovenaan: zolang hij in beeld is, schuiven logo en Trustpilot-link (en op desktop de copy) eronder vandaan via --s7-cc. */
    var cc = d.querySelector('.kn-cc');
    if (cc) {
      var syncCc = function () { var h = cc.classList.contains('is-in') && !cc.hasAttribute('hidden') ? cc.offsetHeight : 0; d.documentElement.style.setProperty('--s7-cc', h + 'px'); };
      new MutationObserver(syncCc).observe(cc, { attributes: true, attributeFilter: ['class', 'hidden'] });
      w.addEventListener('resize', syncCc); w.requestAnimationFrame(function () { w.requestAnimationFrame(syncCc); });
    }
    var roots = d.querySelectorAll('[data-kn-sale-muur]');
    for (var i = 0; i < roots.length; i++) {
      var r = roots[i];
      bootClock(r); bootClockSlide(r); bootEntrance(r); bootWall(r); bootScroll(r); bootForms(r); bootIcs(r); bootReveal(r); bootSticky(r);
    }
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();

  /* ------------------------------------------------------------ 6. plafond (Tufan 14-10: 50.000 max)
     Leest de echte stand uit de app (/apps/kn/cap, Klaviyo-segment 7 JARIG alle aanmeldingen, ontdubbeld) en
     ververst elke 60 s. Bij vol: formulier dicht, wachtlijstregel erin; de inschrijving zelf wordt server-side
     begrensd (de app zet een aanmelding na 50.000 op de wachtlijst). ?kn_cap=full toont de volle stand (preview). */
  (function () {
    var box = d.querySelector('[data-kn-cap]'); if (!box) return;
    var CAP = parseInt(box.getAttribute('data-cap'), 10) || 50000;
    var leftEl = box.querySelector('[data-kn-cap-left]'), bar = box.querySelector('[data-kn-cap-bar]');
    var wait = d.querySelector('[data-kn-wait]');
    function fmt(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
    function paint(count) {
      var left = Math.max(0, CAP - count), full = left === 0;
      if (leftEl) leftEl.textContent = fmt(left);
      if (bar) bar.style.clipPath = 'inset(0 ' + (100 - Math.min(1, count / CAP) * 100).toFixed(2) + '% 0 0)';   /* knippen i.p.v. schalen: het verloop geel → rood blijft op zijn plek */
      box.classList.toggle('is-full', full);
      if (wait) wait.hidden = !full;
      var t = full ? box.getAttribute('data-full-cta') : box.getAttribute('data-cta');
      if (t) [].forEach.call(d.querySelectorAll('[data-kn-mw-form] button[type=submit] .kn-mw__btn-t'), function (el) { el.textContent = t; });
    }
    /* ronde twee (Tufan 19-10): eigen teller "X van 5.000" uit de app (waitlist, waitlistCap); zonder getal blijft hij weg.
       Ook ronde twee vol = formulieren dicht en de regel "Ook ronde twee is vol." */
    var wlBox = d.querySelector('[data-kn-wl]'), wlN = wlBox && wlBox.querySelector('[data-kn-wl-n]'), wlOf = wlBox && wlBox.querySelector('[data-kn-wl-of]'), wlBar = wlBox && wlBox.querySelector('[data-kn-wl-bar]');
    var r2Closed = d.querySelector('[data-kn-r2-closed]');
    var CAP2 = (wait && parseInt(wait.getAttribute('data-cap2'), 10)) || 5000;
    /* preview van een ander ontwerp: ?kn_r2=a|b|box */
    var r2d = location.search.match(/[?&]kn_r2=(a|b|c|box)\b/);
    if (wait && r2d) wait.className = wait.className.replace(/\bkn-mw__r2--\w+/, 'kn-mw__r2--' + r2d[1]);
    function wl(j) {
      if (!wlBox || !wlN) return;
      if (typeof j.waitlistCap === 'number' && j.waitlistCap > 0) CAP2 = j.waitlistCap;
      var ok = typeof j.waitlist === 'number';
      wlBox.hidden = !ok; if (!ok) return;
      wlN.textContent = fmt(j.waitlist);
      if (wlOf) wlOf.textContent = (/kn-mw__r2--c/.test(wait.className) ? '/ ' : 'van ') + fmt(CAP2);
      if (wlBar) wlBar.style.clipPath = 'inset(0 ' + (100 - Math.min(1, j.waitlist / CAP2) * 100).toFixed(2) + '% 0 0)';
      var closed = box.classList.contains('is-full') && j.waitlist >= CAP2;
      wlBox.classList.toggle('is-full', j.waitlist >= CAP2);
      if (r2Closed) r2Closed.hidden = !closed;
      if (wait) wait.classList.toggle('is-closed', closed);
      [].forEach.call(d.querySelectorAll('[data-kn-mw-form]'), function (f) { if (!f.classList.contains('is-done') && f.getAttribute('data-list') !== 'waitlist') f.hidden = closed; });
    }
    /* geen getal in de HTML: pas tonen als de live stand binnen is; komt die de eerste keer niet, dan blijft de teller weg */
    var shown = false;
    function show() { if (shown) return; shown = true; box.hidden = false; w.requestAnimationFrame(function () { box.classList.remove('is-pending'); }); }
    d.addEventListener('kn:cap-full', function () { paint(CAP); show(); });
    if (/[?&]kn_cap=full/.test(location.search)) { paint(CAP); show(); var m2 = location.search.match(/[?&]kn_cap2=(\d+)/); wl({ waitlist: m2 ? +m2[1] : 101 }); return; }
    var src = box.getAttribute('data-src'); if (!src || !w.fetch) { box.hidden = true; return; }
    function pull(first) {
      if (d.hidden && !first) return;
      fetch(src, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          if (j && typeof j.count === 'number') { if (j.cap) CAP = j.cap; paint(j.count); show(); wl(j); }
          else if (!shown) box.hidden = true;
        }).catch(function () { if (!shown) box.hidden = true; });
    }
    pull(true); setInterval(pull, 60000);
  })();
})(window, document);
